import { render, staticRenderFns } from "./PayPeriods.vue?vue&type=template&id=b9c4b3ea&"
import script from "./PayPeriods.vue?vue&type=script&lang=js&"
export * from "./PayPeriods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports